import {View} from 'MWC';
import tpl from '../templates/QuestionBlock.jsx';
import {apiback} from '../../../../config';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);
        this.state = {
            ui: this.uiStates.INITIAL,
            data: []
        };
        this.filterSlidesByEnvironment = this.filterSlidesByEnvironment.bind(this);
        return this;
    }

    filterSlidesByEnvironment(items) {
        if (items) {
            if (window.location.href.includes('a-bank.com.ua')) {
                return items.filter(slide => slide.prod === true);
            } else {
                return items.filter(slide => slide.release === true);
            }
        }
    }

    changeFilesUrl(url) {
        return url ? apiback('API_PAGES') + url.slice(7) : '';
    }

    static defaultProps = {
        title: 'Put your title here',
        id: ''
    };
}
